import React from "react";

const ImageLinkOut = () => {
	return (
		<svg
			className="image-link-out"
			xmlns="http://www.w3.org/2000/svg"
			width="10"
			height="10"
			viewBox="0 0 10 10"
		>
			<path
				className="image-fill-color"
				fill="#00B7BD"
				fillRule="evenodd"
				d="M0 8.963l7.42-7.42H.148v-.086L1.103.5h8.074v8.005L8.151 9.53h-.017V2.303l-6.66 6.66H0z"
			/>
		</svg>
	);
};

export default ImageLinkOut;
